import React from 'react';
import {
  Container,
} from '@mui/material';
import { ConversationSummary, ConversationType } from '@marageti/z4-sdk/lib/travel';
import ConversationLinks from '../../../components/conversation-links';

type MessagesViewProps = {
  tripMatchId: string | undefined
  travelerId: string | undefined
};

const MessagesView = ({
  tripMatchId,
  travelerId,
}:MessagesViewProps) => {
  const renderConversationLink = ({
    conversationSummary,
    tripRequestId,
  }: {
    conversationSummary: ConversationSummary,
    tripRequestId?: string;
  }) => {
    switch (conversationSummary.conversationType) {
      case ConversationType.TravelerToZicasso:
        return `/trip-requests/${tripRequestId}/messages/${conversationSummary.conversationId}`;
      case ConversationType.ZicassoToPartner:
        return `/trip-matches/${tripMatchId}/messages/${conversationSummary.conversationId}`;
      case ConversationType.TravelerToPartner:
        return `/trip-matches/${tripMatchId}/messages/${conversationSummary.conversationId}?viewerId=${travelerId}`;
      default:
        return '';
    }
  };

  return (

    <Container maxWidth="md" sx={{ mb: '100px' }}>
      {tripMatchId && (
        <ConversationLinks
          tripMatchId={tripMatchId}
          renderConversationLink={renderConversationLink}
        />
      )}
    </Container>
  );
};

export default MessagesView;
